export default "__VITE_ASSET__BIIeACyL__"